
export const buyerCompanyIdGraphQLVariableName = 'buyerCompanyId';